import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { GiftCardsWidget } from './GiftCardsWidget'

class HoldstyringGiftCardsElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return GiftCardsWidget
  }

  // Supported HTML attributes:
  //   cta-text="Køb"          — button label (default: "Køb gavekort")
  //   cta-link="/gavekort"    — absolute or path-relative URL to send the buyer to
  protected getWidgetProps() {
    return {
      ctaText: this.getAttribute('cta-text') || null,
      ctaLink: this.getAttribute('cta-link') || null,
    }
  }
}

if (!customElements.get('holdstyring-gift-cards')) {
  customElements.define('holdstyring-gift-cards', HoldstyringGiftCardsElement)
}

export { HoldstyringGiftCardsElement }
